export const APP_PRIMARY_COLOR = '#0274A7';
export const APP_PRIMARY_FONT = 'Poppins';
